import { createBrowserRouter, Navigate } from 'react-router';
import Layout from './components/Layout';
import { PrivateRoute, PublicRoute, RoleRoute } from './components/RootGuard';
import Landing from './pages/Landing';
import Login from './pages/Login';
import NoTenantBlock from './pages/NoTenantBlock';
import Home from './pages/Home';
import Checkout from './pages/Checkout';
import CheckoutTipoDocumento from './pages/CheckoutTipoDocumento';
import CheckoutDocumentoRedirect from './pages/CheckoutDocumento';
import MercadoPagoMock from './pages/MercadoPagoMock';
import AdminFees from './pages/AdminFees';
import AdminPayments from './pages/AdminPayments';
import AdminUsers from './pages/AdminUsers';
import AdminSindicatos from './pages/AdminSindicatos';
import AdminLogs from './pages/AdminLogs';

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/home" replace /> },
  { path: '/landing', element: <Landing /> },
  {
    element: <PublicRoute />,
    children: [
      { path: '/login', element: <Login /> },
    ],
  },
  {
    element: <PrivateRoute />,
    children: [
      { path: '/no-tenant',     element: <NoTenantBlock /> },
      {
        element: <Layout />,
        children: [
          { path: '/home', element: <Home /> },
          { path: '/checkout/tipo', element: <CheckoutTipoDocumento /> },
          { path: '/checkout/:feeCode/documento', element: <CheckoutDocumentoRedirect /> },
          { path: '/checkout/:feeCode', element: <Checkout /> },
          { path: '/mp-mock/:paymentId', element: <MercadoPagoMock /> },
          {
            element: <RoleRoute roles={['TenantAdmin']} />,
            children: [
              { path: '/admin/camaras', element: <AdminSindicatos /> },
              { path: '/admin/sindicatos', element: <Navigate to="/admin/camaras" replace /> },
              { path: '/admin/fees',     element: <AdminFees /> },
              { path: '/admin/payments', element: <AdminPayments /> },
              { path: '/admin/users',    element: <AdminUsers /> },
              { path: '/admin/logs',     element: <AdminLogs /> },
            ],
          },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/home" replace /> },
]);

export default router;
